// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Reselect = require("../../../shared/src/bindings/Reselect.bs.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var UrlHelpers = require("../../../shared/src/UrlHelpers.bs.js");
var WebEnvVars = require("../WebEnvVars.bs.js");
var ApolloClient = require("../../../shared/src/ApolloClient.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var WebTypes_ToDo = require("../types/WebTypes_ToDo.bs.js");
var WebTypes_View = require("../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebTypes_Shift = require("../types/WebTypes_Shift.bs.js");

var version = WebEnvVars.vars.version;

var apiUrl = WebEnvVars.vars.apiUrl;

var getApolloClient = Reselect.createSelector1(undefined, (function (param) {
        return param.token;
      }), (function (param) {
        return ApolloClient.make(apiUrl, /* Web */8, version, param);
      }));

var getAuthorizedClient = Reselect.createSelector2(undefined, (function (param) {
        return param.token;
      }), getApolloClient, (function (token, client) {
        return Relude_Option.map((function (param) {
                      return client;
                    }), token);
      }));

function getTimeAtIntervalInSeconds(n) {
  return Reselect.createSelector1((function (a, b) {
                return Relude_String.eq(a.toISOString(), b.toISOString());
              }), (function (param) {
                return param.timing.currentDatetime;
              }), DateUtils.getDateRoundedToNthSecond(n));
}

var getTimeEveryFiveMinutes = getTimeAtIntervalInSeconds(300);

var getTimeEveryOneMinute = getTimeAtIntervalInSeconds(60);

var getTimeEveryHour = getTimeAtIntervalInSeconds(3600);

var getUrl = Reselect.createSelector1(undefined, (function (param) {
        return param.view;
      }), (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_Globals.$great$great(WebTypes_View.toUrlParts, UrlHelpers.UrlParts.toUrl, param);
                    }), (function (param) {
                      return "/" + param;
                    }), param);
      }));

var getBusinessPastShifts = Reselect.createSelector2(undefined, getTimeEveryHour, (function (param) {
        return param.dashboard.shifts;
      }), (function (currentDatetime) {
        return Curry._1(WebTypes_Shift.$$Set.keep, (function (param) {
                      if (param.cancelledAt !== undefined) {
                        return true;
                      } else {
                        return DateUtils.isBefore(undefined, undefined, currentDatetime)(param.endDatetime);
                      }
                    }));
      }));

var getBusinessUpcomingShifts = Reselect.createSelector2(undefined, getTimeEveryHour, (function (param) {
        return param.dashboard.shifts;
      }), (function (currentDatetime) {
        return Curry._1(WebTypes_Shift.$$Set.keep, (function (param) {
                      if (param.cancelledAt !== undefined) {
                        return false;
                      } else {
                        return DateUtils.isGreaterThanOrEqualTo(undefined, undefined, currentDatetime)(param.endDatetime);
                      }
                    }));
      }));

var partial_arg = Curry._1(Relude_Array.map, WebTypes_ToDo.fromShift);

function partial_arg$1(param) {
  return Relude_Globals.$great$great(WebTypes_Shift.$$Set.toArray, partial_arg, param);
}

var getShiftToDos = Reselect.createSelector1(undefined, (function (param) {
        return param.dashboard.shifts;
      }), (function (param) {
        return Relude_Globals.$great$great(partial_arg$1, WebTypes_ToDo.$$Set.fromArray, param);
      }));

var partial_arg$2 = Curry._1(Relude_Array.map, (function (param) {
        return [
                param.shift,
                param.payTipsToDos
              ];
      }));

var partial_arg$3 = Curry._1(WebTypes_ToDo.$$Set.reject, (function (param) {
        return Relude_Map.isEmpty(param.payTipsToDos);
      }));

function partial_arg$4(param) {
  return Relude_Globals.$great$great(partial_arg$3, WebTypes_ToDo.$$Set.toArray, param);
}

function partial_arg$5(param) {
  return Relude_Globals.$great$great(partial_arg$4, partial_arg$2, param);
}

var getPayTipsToDos = Reselect.createSelector1(undefined, getShiftToDos, (function (param) {
        return Relude_Globals.$great$great(partial_arg$5, WebTypes_ToDo.Shift.$$Map.fromArray, param);
      }));

var partial_arg$6 = Curry._2(Relude_Array.foldLeft, (function (total, workerShifts) {
        return total + Relude_Map.length(workerShifts) | 0;
      }), 0);

var getPayTipsToDoAlertCount = Reselect.createSelector1(undefined, getPayTipsToDos, (function (param) {
        return Relude_Globals.$great$great(Relude_Map.valueArray, partial_arg$6, param);
      }));

var getToDoAlertCount = Reselect.createSelector1(undefined, getPayTipsToDoAlertCount, Relude_Globals.id);

exports.apiUrl = apiUrl;
exports.version = version;
exports.getApolloClient = getApolloClient;
exports.getAuthorizedClient = getAuthorizedClient;
exports.getTimeAtIntervalInSeconds = getTimeAtIntervalInSeconds;
exports.getTimeEveryFiveMinutes = getTimeEveryFiveMinutes;
exports.getTimeEveryOneMinute = getTimeEveryOneMinute;
exports.getTimeEveryHour = getTimeEveryHour;
exports.getUrl = getUrl;
exports.getBusinessPastShifts = getBusinessPastShifts;
exports.getBusinessUpcomingShifts = getBusinessUpcomingShifts;
exports.getShiftToDos = getShiftToDos;
exports.getPayTipsToDos = getPayTipsToDos;
exports.getPayTipsToDoAlertCount = getPayTipsToDoAlertCount;
exports.getToDoAlertCount = getToDoAlertCount;
/* getApolloClient Not a pure module */
